/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Final_HeadingInputs */



/**
* | output |
* | --- |
* | "League final" |
*
* @param {League_Final_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_final_heading = /** @type {((inputs?: League_Final_HeadingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Final_HeadingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Finale de ligue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Final de liga")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Final da liga")
	if (locale === "it") return /** @type {LocalizedString} */ ("Finale del campionato")
	return /** @type {LocalizedString} */ ("League final")
});